import { createCollectionReducer } from 'next/lib/collections';
import { TYPE } from './actions';

export default createCollectionReducer(TYPE);

export const selectTranslations = state => state[TYPE];
